import { StyleSheet } from "@react-pdf/renderer";

// Create styles
export const styles = StyleSheet.create({
  page: {
    paddingTop: 30,
    paddingRight: 50,
    paddingBottom: 10,
    paddingLeft: 50,
    // maxWidth: "96%",
    fontFamily: "Roboto",
    fontSize: 8,
    color: "#4c4c4c",
    position: "relative",
  },
  logoContainer: {
    paddingBottom: 24,
  },
  logo: {
    width: 150,
  },

  link: {
    color: "#4c4c4c",
  },
  marginTop: {
    marginTop: 10,
  },
  flex_container: {
    self: {
      display: "flex",
      flexDirection: "row",
      flexWrap: "noWrap",
    },
    wrap: {
      flexWrap: "wrap",
    },
    fit_content: {
      flexGrow: 0,
      flexShrink: 1,
      marginLeft: 5,
    },
    fit_content_first_item: {
      marginLeft: 0,
    },
    empty_item: {
      flexGrow: 1,
      flexShrink: 0,
      flexBasis: "1%",
    },
  },
  curved_borders: {
    borderRadius: 12,
    borderWidth: 0.75,
    borderStyle: "solid",
    marginTop: 3.75,
    paddingTop: 2.25,
    paddingRight: 2.25,
    paddingBottom: 2.25,
    paddingLeft: 2.25,
  },
  primary: {
    color: "#e41b13",
    borderColor: "#e41b13",
  },
  tertiary: {
    color: "#000000",
  },
  quinary: {
    backgroundColor: "#e8e8e8",
    color: "#000000",
    borderColor: "#e8e8e8",
  },
  quaternary: {
    backgroundColor: "#4c4c4c",
    color: "#fff",
    borderColor: "#4c4c4c",
  },
  firstRow: {
    self: {
      paddingBottom: 24,
    },
    city: {
      fontSize: 8,
    },
    name: {
      fontSize: 21,
      paddingTop: 6,
      PaddingBottom: 12,
    },
    member_type: {
      textAlign: "center",
      display: "flex",
      flexDirection: "row",
      flexWrap: "noWrap",
    },
    member_type_item: {
      flexShrink: 1,
      flexGrow: 0,
    },
    member_type_stealth_item: {
      flexShrink: 0,
      flexGrow: 1,
      flexBasis: "1%",
    },
  },
  secondRow: {
    self: {
      display: "flex",
      flexDirection: "row",
      flexWrap: "unwrap",
      justifyContent: "flex-start",
    },
    left: {
      self: {
        display: "flex",
        flexDirection: "column",
        width: "50%",
      },
      address: {
        color: "#e41b13",
        fontSize: 7,
        paddingBottom: 3.75,
      },
      addLine: {
        fontSize: 8,
      },
      contact: {
        paddingTop: 12,
      },
    },
    right: {
      self: {
        display: "flex",
        flexDirection: "column",
        width: "50%",
        paddingLeft: 5,
      },
      block: {
        paddingBottom: 5,
      },
      block_title: {
        color: "#e41b13",
        fontSize: 7,
        paddingBottom: 3.75,
      },
      addLine: {
        fontSize: 8,
      },
    },
  },
  thirdRow: {
    title: {
      marginTop: 10,
      fontWeight: "bold",
      borderBottomWidth: 0.75,
      borderBottomStyle: "solid",
      borderBottomColor: "#d4d4d4",
      paddingBottom: 12,
    },

    self: {
      paddingTop: 10,
      display: "flex",
      flexDirection: "row",
      flexWrap: "unwrap",
      justifyContent: "flex-start",
    },
    left: {
      self: {
        width: "50%",
      },
      contact: {
        paddingBottom: 12,
        color: "#4c4c4c",
      },
    },
    right: {
      self: {
        width: "50%",
      },
      block_title: {
        marginLeft: 5,
        color: "#e41b13",
        fontSize: 7,
        paddingBottom: 3.75,
      },
      statment_title: {
        color: "#e41b13",
        paddingBottom: 3.75,
      },
    },
  },
  footer: {
    position: "absolute",
    left: 50,
    bottom: 12,
  },
});
